import { render, staticRenderFns } from "./AddDocType.vue?vue&type=template&id=592527ec&scoped=true&"
import script from "./AddDocType.vue?vue&type=script&lang=js&"
export * from "./AddDocType.vue?vue&type=script&lang=js&"
import style0 from "./AddDocType.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddDocType.vue?vue&type=style&index=1&id=592527ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592527ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('592527ec')) {
      api.createRecord('592527ec', component.options)
    } else {
      api.reload('592527ec', component.options)
    }
    module.hot.accept("./AddDocType.vue?vue&type=template&id=592527ec&scoped=true&", function () {
      api.rerender('592527ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/documents/AddDocType.vue"
export default component.exports